import { render, staticRenderFns } from "./PhoneTwo.vue?vue&type=template&id=133690d2&scoped=true&"
import script from "./PhoneTwo.vue?vue&type=script&lang=js&"
export * from "./PhoneTwo.vue?vue&type=script&lang=js&"
import style0 from "./PhoneTwo.vue?vue&type=style&index=0&id=133690d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133690d2",
  null
  
)

export default component.exports